import { render, staticRenderFns } from "./projectComponentsCard.vue?vue&type=template&id=ed95fed2&scoped=true"
import script from "./projectComponentsCard.vue?vue&type=script&lang=js"
export * from "./projectComponentsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed95fed2",
  null
  
)

export default component.exports